import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserActivityLogService {

  constructor(private http: HttpClient) { }

  //Report

  ReadUserActivityLog(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/report/read`, params);
  }
  
  //Report ProIncome

  ReadProIncomeList(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/report/pro/income/list`, params);
  }

  UpdateProIncome(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/report/pro/income/update`, params);
  }

  //ReportDiscount

  ReadReportDiscountList(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/report/discount/list`, {otp: params});
  }

  AddReportDiscount(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/report/discount/add`, params);
  }

  UpdateReportDiscount(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/report/discount/update`, params);
  }

  DeleteReportDiscount(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/report/discount/delete`, params);
  }
}
